var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "app-loader",
    class: ['al--' + _vm.look, _vm.lookClass, {
      'app-loader--held': _vm.prefs.hold || _vm.prefs.pause
    }],
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('ui-load-card', {
    attrs: {
      "steps": _vm.shownSteps,
      "progress": _vm.shownProgress,
      "look": _vm.look,
      "title": _vm.$t('app_loader.title')
    }
  }, [_vm.slow && !_vm.demo ? _c('div', {
    staticClass: "app-loader__slow"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('app_loader.slow')))]), _c('div', {
    staticClass: "app-loader__actions"
  }, [_c('button', {
    staticClass: "app-loader__btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.$t('app_loader.retry')))]), _c('button', {
    staticClass: "app-loader__btn app-loader__btn--quiet",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('open');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_loader.open_anyway')))])])]) : _vm._e()])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };